import { useLocation, useRouter } from '@tanstack/react-router';
import { ArrowLeft } from 'lucide-react';

import { buildBreadcrumbs } from '../../shared/helpers/build-breadcrumbs';
import { FilterBreadcrumb } from '../../shared/ui/filter-breadcrumb';

import type { DateRange } from '@/entities/query/index';
import { Button } from '@/shared/components/shadcn/button';
import { DATE_FORMATS } from '@/shared/utils/date/date-formats';
import dayjs from 'dayjs';

interface Props {
  queryName: string;
  dateRange: DateRange;
}

export function FilteredPostsHeader({ queryName, dateRange }: Props) {
  const location = useLocation();
  const router = useRouter();
  const searchParams = new URLSearchParams(location.search);

  const handleBack = () => {
    router.history.back();
  };

  const breadcrumbSegments = [
    ...buildBreadcrumbs(queryName, searchParams),
    {
      label: `${dayjs(dateRange.startDate).format(DATE_FORMATS.base)} - ${dayjs(dateRange.endDate).format(DATE_FORMATS.base)}`,
    },
  ];

  return (
    <div className="bg-background flex flex-col px-6 pb-2">
      <Button className="my-8 w-fit" variant="outline" size="default" onClick={handleBack}>
        <ArrowLeft className="size-4" />
        Back
      </Button>
      <FilterBreadcrumb segments={breadcrumbSegments} />
    </div>
  );
}
